import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { SafetyEntities } from 'client/data/models/safety';
import { SCROLL_OFFSET, SCROLL_DURATION } from 'site-modules/shared/constants/sub-navigation';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';
import { isNhtsaRatingsEmpty } from './utils';
import { SafetyNhtsaRatings } from './safety-nhtsa-ratings';
import { SafetyIihsRatings } from './safety-iihs-ratings';

const MOBILE_HEIGHT = 80;
const DESKTOP_HEIGHT = 52;

function SafetyRatingsUI({ nhtsaRatings, iihsRatings, isMobile }) {
  const isNhtsaEmpty = isNhtsaRatingsEmpty(nhtsaRatings);
  const isIihsEmpty = isEmpty(iihsRatings);

  if (isNhtsaEmpty && isIihsEmpty) {
    return null;
  }

  return (
    <div className="core-safety-ratings">
      <ContentCollapse
        minHeight={`${isMobile ? MOBILE_HEIGHT : DESKTOP_HEIGHT}px`}
        textClosed="See full safety scores"
        textOpen="See less"
        isEclipseFade={false}
        classes="safety-ratings-collapse"
        btnClasses="safety-ratings-collapse-btn size-16 text-primary-darker px-0_5 pt-0_5 pb-0 text-transform-none"
        btnTextClasses="fw-normal"
        btnContainerClasses="p-0"
        trackingId="core_page_view_content_safety_ratings"
        showBtnBelow
        justify=""
        resetParams={{
          offset: SCROLL_OFFSET,
          duration: SCROLL_DURATION,
          to: 'scrollTop-safety',
        }}
      >
        <SafetyNhtsaRatings nhtsaRatings={nhtsaRatings} />
        <SafetyIihsRatings iihsRatings={iihsRatings} />
      </ContentCollapse>
    </div>
  );
}

SafetyRatingsUI.propTypes = {
  nhtsaRatings: SafetyEntities.NhtsaRatings,
  iihsRatings: SafetyEntities.IihsRatings,
  isMobile: PropTypes.bool,
};

SafetyRatingsUI.defaultProps = {
  nhtsaRatings: null,
  iihsRatings: null,
  isMobile: false,
};

const mapStateToProps = ({ mobile }) => ({
  isMobile: mobile,
});

export const SafetyRatings = connect(mapStateToProps)(SafetyRatingsUI);
